// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon-text-flex-column{flex-direction:column}.icon-text-flex-row{flex-direction:row}.icon-size{width:20px;height:20px}.text{margin-top:3px}.icon-text-button{display:flex;align-items:center;justify-content:center;border:1px solid #e0e0e0;flex-direction:column;width:60px;height:60px}.icon-text-button-icon{overflow:hidden!important}.icon-text-button-icon:hover{background:#e0e0e0}.icon-text-button:hover{cursor:pointer;background:#e0e0e0}", ""]);
// Exports
module.exports = exports;
